module.exports = __webpack_public_path__ + "img/payment-list.191b46bf.svg";